import styled from "styled-components";

import { PrimaryText } from "@/components/Typography/Styled";

export const StyledSalaryAmount = styled(PrimaryText)`
    color: ${(props) => props.theme.lightBlue} !important;
`;
